import React, { FC } from "react";

import Button from "components/BaseComponents/Button";
import Image from "components/BaseComponents/Image";
import { ICONS } from "components/BaseComponents/Image/Image.constants";

import { SuccessProps } from "./Success.constant";
import { StyledButton, StyledOuterContainer } from "./Success.styles";

const Success: FC<SuccessProps> = ({ onClick, buttonText }) => {
  return (
    <StyledOuterContainer>
      <Image
        alt='Success Icon'
        height='240px'
        srcSet={ICONS.SUCCESS}
        width='240px'
      />

      <StyledButton>
        <Button onClick={onClick} text={buttonText} autoFocus />
      </StyledButton>
    </StyledOuterContainer>
  );
};

export default Success;
